<template>
    <div id="notification-wrapper" v-show="notifications.length > 0">
        <div v-for="notification in notifications" :key="notification.conversationId">
            <div id="notifications-container" class="notification-popup right">
                <div class="notifications-container">
                    <div
                        class="notification-content"
                        @click="!hasJoinMeetingBtn ? navigateToConversation(notification) : null"
                    >
                        <div class="d-flex align-items-center">
                            <div class="initials-wrapper">
                                <div class="ava-initials me-1">
                                    {{ fullNameToInitials(notification.senderName) }}
                                </div>
                            </div>
                            <div class="ms-3 flex-grow-1 name-container">
                                <strong class="noti-title" :class="{ 'noti.out': notification.clicked }">
                                    {{ notification.senderName }}
                                </strong>

                                <div class="w-100 d-flex">
                                    <span v-show="notification.isImportant" class="important-icon mt-2 me-2"
                                        ><i class="fas fa-exclamation"></i
                                    ></span>
                                    <p
                                        class="mt-2 message-body"
                                        v-html="sanitizeMarkup(markdownToHtml(notification.messageBody))"
                                        v-if="notification.messageBody"
                                    ></p>
                                </div>
                                <div class="d-flex flex-column" v-if="notification.messageAssets?.length > 0">
                                    <img class="media-icon" src="../../../../assets/images/social-media.png" />
                                    <button class="btn btn-primary btn-sm mt-2">View media assets</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <i
                        class="close-button fas fa-times m-2 align-self-start"
                        :class="{ 'pe-none': getReplyState(notification.conversationId).isSending }"
                        @click="closeChatNotification(notification.conversationId)"
                    ></i>
                </div>
                <!-- Divider -->
                <div class="divider"></div>

                <!-- Reply Section -->
                <div class="reply-section">
                    <!-- Expanded Reply Input -->
                    <div v-if="getReplyState(notification.conversationId).isReplying" class="reply-input-container">
                        <input
                            :value="getReplyState(notification.conversationId).replyText"
                            @input="
                                updateReplyText(notification.conversationId, ($event.target as HTMLInputElement).value)
                            "
                            @keyup.enter="sendReply(notification.conversationId)"
                            @keyup.escape="cancelReply(notification.conversationId)"
                            placeholder="Reply"
                            class="reply-input"
                            :disabled="getReplyState(notification.conversationId).isSending"
                            autofocus
                        />

                        <img
                            :class="`send-btn cursor-pointer ${
                                !isReplyValid(notification.conversationId) ? 'disableSend' : ''
                            }`"
                            src="../../../../assets/images/chat/send.svg"
                            @click="sendReply(notification.conversationId)"
                        />
                    </div>

                    <!-- Collapsed Reply Button -->
                    <div v-else class="reply-button-container">
                        <!--  REACTIONS LIST -->
                        <div v-if="getReplyState(notification.conversationId).isReacting">
                            <div class="emoji-options">
                                <span
                                    v-for="emoji in Object.values(ReactionEmojisEnum)"
                                    :key="emoji"
                                    class="emoji-item"
                                    @click="sendReaction(notification.conversationId, notification.messageId, emoji)"
                                >
                                    {{ emoji }}
                                </span>
                            </div>
                        </div>
                        <!--  OPEN REACTIONS BUTTON -->
                        <button
                            v-else
                            class="btn btn-outline-secondary add-reaction-btn"
                            @click="showReactions(notification.conversationId)"
                        >
                            <img src="../../../../assets/images/chat/add-reaction.svg" />
                        </button>
                        <button
                            @click="showReplyInput(notification.conversationId)"
                            class="reply-button"
                            :class="{ 'pe-none': getReplyState(notification.conversationId).isSending }"
                        >
                            Reply
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <call-notification
        v-if="callSignalRNotification"
        :call-signal-r-notification="callSignalRNotification"
        @close-notification="closeNotificationPopup"
        @decline-call="handleCallDecline"
        @accept-call="handleCallAccept(callSignalRNotification)"
    />
    <OutgoingCallNotification
        v-if="outgoingCallNotification"
        :outgoingCallNotification="outgoingCallNotification"
        :recipientDeclined="recipientDeclined"
        @close-notification="closeOutgoingPopup"
        @decline-call="handleOutgoingCallDecline"
        @unanswered-call="handleCallUnanswered"
        :callControls="callControls"
        @audio-changed="handleAudioChange"
        @video-changed="handleVideoChange"
        @retry-call="handleRetryCall"
    />
</template>

<script lang="ts" src="./Notification"></script>
<style src="./Notification.scss"></style>
